
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    start: {
      type: Number,
      required: true,
      default: 0
    },
    end: {
      type: Number,
      required: true,
    },
    bold: {
      type: Boolean,
      default: false
    }
    
  },
  mounted () {
    this.addTag()
  },
  methods: {
    addTag () {
      const bloques = this.text.split(' ');
      let result = ''
      const myClass = this.bold ? 'text-bold' : 'mark-text'
      bloques.forEach((word, index) => {
        if (index === this.start){
          result = result + '<span class="' + myClass + '">'
        }
        if (index === this.end) {
          result = result + '</span>'
        }
        result = result + ' ' + word
      })
      this.$el.innerHTML = result
    }
  }
}
